import { signIn, signOut, authListener } from "../firebase/auth";

export const SESSION_LOGIN_SUCCESS = "SESSION_LOGIN_SUCCESS";
export const SESSION_LOGIN_FAIL = "SESSION_LOGIN_FAIL";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const CHECK_TOKEN = "CHECK_TOKEN";

export default async function loginHandler({ type: action, payload }) {
	switch (action) {
		case LOGIN:
			try {
				const user = await signIn(payload);
				const userData = await user.json();
				if (user.status === 200) {
					return {
						status: SESSION_LOGIN_SUCCESS,
						userData,
					};
				}
				return { status: SESSION_LOGIN_FAIL, user };
			} catch (error) {
				return { status: SESSION_LOGIN_FAIL, error };
			}

		case CHECK_TOKEN:
			try {
				const user = await authListener();
				if (user) {
					if (user.uid === payload.uid) {
						return { status: SESSION_LOGIN_SUCCESS, user };
					} else {
						signOut();
						return { status: SESSION_LOGIN_FAIL };
					}
				}
				return { status: SESSION_LOGIN_FAIL };
			} catch (error) {
				return { status: SESSION_LOGIN_FAIL, error };
			}
		case LOGOUT:
			signOut();
			break;

		default:
			return { status: SESSION_LOGIN_FAIL };
	}
}
